'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconNotebook, iconNotebookTag } from '@ni/nimble-components/dist/esm/icons/notebook';
import { wrap } from '../../utilities/react-wrapper';

export type { IconNotebook };
export { iconNotebookTag };
export const NimbleIconNotebook = wrap(IconNotebook);